var _routeNames$referralP, _routeNames$referralP2, _routeNames$referralP3, _routeNames$referralP4, _routeNames$referralP5, _routeNames$referralP6, _routeNames$settings$, _routeNames$settings$2, _routeNames$settings$3, _routeNames$settings$4;
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.flat-map.js";
import "core-js/modules/esnext.iterator.map.js";
import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { isLogged, alreadyLogged, isLoggedAndActive, hasPermission, hasRole, emailVerification } from "./middlewares";
import NavSideBar from "../views/dashboard/main/mcn-dashboard";
import goTo from 'vuetify/lib/services/goto';
import { languages } from "@/assets/js/global-constants";
import i18n from "../plugins/vueI18n";
import { PERMISSIONS } from "@/assets/js/mcn-helpers";

// this extension is to suppress vue-router's redirect error
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => {
    if (VueRouter.isNavigationFailure(err)) {
      // resolve err
      return err;
    }
    // rethrow error
    return Promise.reject(err);
  });
};
Vue.use(VueRouter);
let routeNames = new NavSideBar();
let dashBoardLang = {
  path: '/:lang',
  component: () => import(/* webpackChunkName: "Root" */'../App.vue'),
  children: [{
    path: '',
    component: () => import(/* webpackChunkName: "MCNDashboard" */'../views/dashboard/main/MCNDashboard.vue'),
    meta: {
      middleware: [isLoggedAndActive]
    },
    children: [{
      path: '',
      name: routeNames.OverviewPage.translation_name,
      component: () => import(/* webpackChunkName: "MainPage" */'../views/dashboard/overview/MainPage'),
      meta: {
        id: routeNames.OverviewPage.id,
        mcn_permission: routeNames.OverviewPage.permission,
        middleware: [hasPermission]
      }
    }, {
      path: "applications",
      component: () => import(/* webpackChunkName: "BusinessManagerPage" */"../views/dashboard/business-managers/BusinessManagers"),
      meta: {
        model: routeNames.BusinessManagersPage,
        mcn_permission: routeNames.BusinessManagersPage.permission,
        middleware: [hasPermission]
      },
      children: [
      /*                        {
                                  path: "woocommerce",
                                  name: routeNames.BusinessManagersPage.children[0].translation_name,
                                  component: () => import(/!* webpackChunkName: "WooCommercePage" *!/ "../views/dashboard/business-managers/WooCommerce"),
                                  meta: {
                                      mcn_permission: routeNames.BusinessManagersPage.children[0].permission,
                                      middleware: [
                                          hasPermission,
                                      ]
                                  }
                              },*/
      {
        path: "google-sheet",
        name: routeNames.BusinessManagersPage.children[0].translation_name,
        component: () => import(/* webpackChunkName: "GoogleSheetPage" */"../views/dashboard/business-managers/GoogleSheet/GoogleSheet.vue"),
        meta: {
          mcn_permission: routeNames.BusinessManagersPage.children[0].permission,
          middleware: [hasPermission]
        }
      }, {
        path: "google-shopping",
        name: routeNames.BusinessManagersPage.children[1].translation_name,
        component: () => import(/* webpackChunkName: "GoogleShoppingPage" */"../views/dashboard/business-managers/GoogleShopping"),
        meta: {
          mcn_permission: routeNames.BusinessManagersPage.children[1].permission,
          middleware: [hasPermission]
        }
      }, {
        path: "facebook-shopping",
        name: routeNames.BusinessManagersPage.children[2].translation_name,
        component: () => import(/* webpackChunkName: "FacebookShoppingPage" */"../views/dashboard/business-managers/FacebookShopping"),
        meta: {
          mcn_permission: routeNames.BusinessManagersPage.children[2].permission,
          middleware: [hasPermission]
        }
      }]
    }, {
      path: 'notification',
      name: 'dashboardMenu.notifications.title',
      component: () => import(/* webpackChunkName: "NotificationsPage" */'../views/dashboard/notification/NotificationsPage'),
      meta: {
        mcn_permission: PERMISSIONS.NOTIFICATIONS.ID,
        middleware: [hasPermission]
      }
    }, {
      path: 'order',
      name: routeNames.OrderPage.translation_name,
      component: () => import(/* webpackChunkName: "OrderPage" */'../views/dashboard/order/OrderPage'),
      meta: {
        id: routeNames.OrderPage.id,
        mcn_permission: routeNames.OrderPage.permission,
        middleware: [hasPermission]
      }
    },
    /*{
        path: 'sale-page/generated-sale-pages',
        name: routeNames.SalePageManagementPage.children[1].translation_name,
        component: () => import( /!* webpackChunkName: "SalePageInstances" *!/ '../views/dashboard/sale-page/SalePageInstances'),
        meta: {
            id: routeNames.SalePageManagementPage.children[1].id,
            mcn_permission: routeNames.SalePageManagementPage.children[1].permission,
            middleware: [
                hasPermission,
            ]
        }
    },
    {
        path: 'sale-page',
        name: routeNames.SalePageManagementPage.children[0].translation_name,
        component: () => import( /!* webpackChunkName: "SalePagePrototypes" *!/ '../views/dashboard/sale-page/SalePagePrototypes'),
        meta: {
            id: routeNames.SalePageManagementPage.children[0].id,
            mcn_permission: routeNames.SalePageManagementPage.children[0].permission,
            middleware: [
                hasPermission,
            ]
        }
    },*/
    {
      path: 'product-sale-page',
      name: routeNames.productSalePage.translation_name,
      component: () => import(/* webpackChunkName: "ProductSalePage" */'../views/dashboard/productSalePage/ProductSalePage'),
      meta: {
        id: routeNames.productSalePage.id,
        mcn_permission: routeNames.productSalePage.permission,
        middleware: [hasPermission]
      }
    },
    /*{
        path: 'pre-sell-page/generated-pre-sell-pages',
        name: routeNames.PreSalePageManagementPage.children[1].translation_name,
        component: () => import( /!* webpackChunkName: "PreSellPageInstances" *!/ '../views/dashboard/pre-sell-page/PreSellPageInstances'),
        meta: {
            id: routeNames.PreSalePageManagementPage.children[1].id,
            mcn_permission: routeNames.PreSalePageManagementPage.children[1].permission,
            middleware: [
                hasPermission,
            ]
        }
    },
    {
        path: 'pre-sell-page',
        name: routeNames.PreSalePageManagementPage.children[0].translation_name,
        component: () => import( /!* webpackChunkName: "PreSellPagePrototypes" *!/ '../views/dashboard/pre-sell-page/PreSellPagePrototypes'),
        meta: {
            id: routeNames.PreSalePageManagementPage.children[0].id,
            mcn_permission: routeNames.PreSalePageManagementPage.children[0].permission,
            middleware: [
                hasPermission,
            ]
        }
    },*/
    {
      path: 'store/domain',
      name: routeNames.store.children[0].translation_name,
      component: () => import(/* webpackChunkName: "StoreDomainsPage" */'../../src/components/sub/dynamic/settings/domain/Domain'),
      meta: {
        mcn_permission: routeNames.store.children[0].permission,
        mcn_permitted_roles: routeNames.store.children[0].permitted_roles,
        middleware: [hasPermission, hasRole]
      }
    }, {
      path: 'store',
      name: routeNames.store.children[1].translation_name,
      component: () => import(/* webpackChunkName: "StoreSettingsPage" */'../views/dashboard/store-pages/store-settings/StoreSettingsPage'),
      meta: {
        id: routeNames.store.children[1].id,
        mcn_permission: routeNames.store.children[1].permission,
        middleware: [hasPermission]
      }
    }, {
      path: 'store/page',
      name: routeNames.store.children[2].translation_name,
      component: () => import(/* webpackChunkName: "StorePagesPage" */'../views/dashboard/store-pages/StorePagesPage'),
      meta: {
        id: routeNames.store.children[2].id,
        mcn_permission: routeNames.store.children[2].permission,
        middleware: [hasPermission]
      }
    }, {
      path: 'store/layout',
      name: routeNames.store.children[3].translation_name,
      component: () => import(/* webpackChunkName: "StoreLayoutPage" */'../views/dashboard/store-pages/store-layout/StoreLayoutPage'),
      meta: {
        id: routeNames.store.children[3].id,
        mcn_permission: routeNames.store.children[3].permission,
        middleware: [hasPermission]
      }
    }, {
      path: "store/library",
      name: routeNames.store.children[4].translation_name,
      component: () => import(/* webpackChunkName: "StoreLibraryPage" */"../views/dashboard/library/MediaLibraryPage"),
      meta: {
        mcn_permission: routeNames.store.children[4].permission,
        middleware: [hasPermission]
      }
    }, {
      path: 'sale-report',
      name: routeNames.SaleReportPage.translation_name,
      component: () => import(/* webpackChunkName: "SaleReportsPage" */'../views/dashboard/sale-report-page/SaleReportsPage'),
      meta: {
        id: routeNames.SaleReportPage.id,
        mcn_permission: routeNames.SaleReportPage.permission,
        middleware: [hasPermission]
      }
    }, {
      path: 'support',
      name: routeNames.SupportPage.translation_name,
      component: () => import(/* webpackChunkName: "SupportPage" */'../views/dashboard/support/SupportPage'),
      redirect: 'support/faq',
      meta: {
        id: routeNames.SupportPage.id,
        mcn_permission: routeNames.SupportPage.permission,
        middleware: [hasPermission]
      },
      children: [{
        path: 'faq',
        name: routeNames.SupportPage.children[0].translation_name,
        component: () => import(/* webpackChunkName: "FaqPage" */'../views/dashboard/support/FaqPage'),
        meta: {
          mcn_permission: routeNames.SupportPage.children[0].permission,
          middleware: [hasPermission]
        }
      }, {
        path: 'ticket',
        name: routeNames.SupportPage.children[1].translation_name,
        component: () => import(/* webpackChunkName: "TicketPage" */'../views/dashboard/support/TicketPage'),
        meta: {
          id: routeNames.SupportPage.children[1].id,
          mcn_permission: routeNames.SupportPage.children[1].permission,
          middleware: [hasPermission]
        }
      }, {
        path: 'tutorials',
        name: routeNames.SupportPage.children[2].translation_name,
        component: () => import(/* webpackChunkName: "TutorialsPage" */'../views/dashboard/tutorial/TutorialsPage'),
        meta: {
          id: routeNames.SupportPage.children[2].id,
          mcn_permission: routeNames.SupportPage.children[2].permission,
          middleware: [hasPermission]
        }
      }]
    }, {
      path: 'warehouse-settings',
      name: routeNames.WarehousePage.translation_name,
      component: () => import(/* webpackChunkName: "WarehouseRouter" */'../views/dashboard/warehouse/WarehouseRouter'),
      meta: {
        id: routeNames.WarehousePage.id,
        mcn_permission: routeNames.WarehousePage.permission,
        middleware: [hasPermission]
      },
      children: [{
        path: 'warehouses',
        name: routeNames.WarehousePage.children[0].translation_name,
        component: () => import(/* webpackChunkName: "Warehouses" */'../views/dashboard/warehouse/Warehouses'),
        meta: {
          mcn_permission: routeNames.WarehousePage.children[0].permission,
          middleware: [hasPermission]
        }
      }, {
        path: "inventory",
        name: routeNames.WarehousePage.children[1].translation_name,
        component: () => import(/* webpackChunkName: "WarehouseInventoryPage" */"../views/dashboard/inventory-overview/InventoryOverview"),
        meta: {
          mcn_permission: routeNames.WarehousePage.children[1].permission,
          middleware: [hasPermission]
        }
      }, {
        path: 'network-sdks',
        name: routeNames.WarehousePage.children[2].translation_name,
        component: () => import(/* webpackChunkName: "NetworkSdkAccountsPage" */'../views/dashboard/network-sdks/NetworkSdkAccountsPage'),
        meta: {
          mcn_permission: routeNames.WarehousePage.children[2].permission,
          middleware: [hasPermission]
        }
      }]
    }, {
      path: 'advertiser',
      name: routeNames.AdvertiserPage.translation_name,
      component: () => import(/* webpackChunkName: "AdvertiserPage" */'../views/dashboard/advertiser/AdvertiserPage'),
      meta: {
        mcn_permission: routeNames.AdvertiserPage.permission,
        middleware: [hasPermission]
      }
    }, {
      path: "product",
      name: routeNames.ProductPage.translation_name,
      component: () => import(/* webpackChunkName: "ProductPage" */"../views/dashboard/Product/ProductPage"),
      meta: {
        mcn_permission: routeNames.ProductPage.permission,
        middleware: [hasPermission]
      }
    }, {
      path: "sellers",
      name: routeNames.SellersPage.translation_name,
      component: () => import(/* webpackChunkName: "SellersPage" */"../views/dashboard/seller/SellersPage"),
      meta: {
        mcn_permission: routeNames.SellersPage.permission,
        middleware: [hasPermission]
      }
    }, {
      path: "referral-program",
      name: routeNames.referralProgram.translation_name,
      component: () => import(/* webpackChunkName: "ReferralProgram" */"../views/dashboard/referral-program/ReferralProgram"),
      meta: {
        mcn_permission: routeNames.referralProgram.permission,
        middleware: [hasPermission]
      },
      children: [{
        path: "link",
        name: (_routeNames$referralP = routeNames.referralProgram.children) === null || _routeNames$referralP === void 0 || (_routeNames$referralP = _routeNames$referralP[0]) === null || _routeNames$referralP === void 0 ? void 0 : _routeNames$referralP.translation_name,
        component: () => import(/* webpackChunkName: "ReferralLink" */"../views/dashboard/referral-program/ReferralLink"),
        meta: {
          mcn_permission: (_routeNames$referralP2 = routeNames.referralProgram.children) === null || _routeNames$referralP2 === void 0 || (_routeNames$referralP2 = _routeNames$referralP2[0]) === null || _routeNames$referralP2 === void 0 ? void 0 : _routeNames$referralP2.permission,
          middleware: [hasPermission]
        }
      }, {
        path: "invoice",
        name: (_routeNames$referralP3 = routeNames.referralProgram.children) === null || _routeNames$referralP3 === void 0 || (_routeNames$referralP3 = _routeNames$referralP3[1]) === null || _routeNames$referralP3 === void 0 ? void 0 : _routeNames$referralP3.translation_name,
        component: () => import(/* webpackChunkName: "ReferralInvoices" */"../views/dashboard/referral-program/ReferralInvoices"),
        meta: {
          mcn_permission: (_routeNames$referralP4 = routeNames.referralProgram.children) === null || _routeNames$referralP4 === void 0 || (_routeNames$referralP4 = _routeNames$referralP4[1]) === null || _routeNames$referralP4 === void 0 ? void 0 : _routeNames$referralP4.permission,
          middleware: [hasPermission]
        }
      }, {
        path: "payouts",
        name: (_routeNames$referralP5 = routeNames.referralProgram.children) === null || _routeNames$referralP5 === void 0 || (_routeNames$referralP5 = _routeNames$referralP5[2]) === null || _routeNames$referralP5 === void 0 ? void 0 : _routeNames$referralP5.translation_name,
        component: () => import(/* webpackChunkName: "ReferralPayouts" */"../views/dashboard/referral-program/ReferralPayouts"),
        meta: {
          mcn_permission: (_routeNames$referralP6 = routeNames.referralProgram.children) === null || _routeNames$referralP6 === void 0 || (_routeNames$referralP6 = _routeNames$referralP6[2]) === null || _routeNames$referralP6 === void 0 ? void 0 : _routeNames$referralP6.permission,
          middleware: [hasPermission]
        }
      }]
    }, {
      path: "call-center",
      name: routeNames.CallCenterPage.translation_name,
      component: () => import(/* webpackChunkName: "CallCenterPage" */"../views/dashboard/call-center/CallCenter"),
      meta: {
        mcn_permission: routeNames.CallCenterPage.permission,
        middleware: [hasPermission]
      }
    }, {
      path: "log",
      name: routeNames.LogPage.translation_name,
      component: () => import(/* webpackChunkName: "ActivityLogsPage" */"../views/dashboard/activity-logs/ActivityLogsPage"),
      meta: {
        mcn_permission: routeNames.LogPage.permission,
        middleware: [hasPermission]
      }
    },
    /*                {
                        path: "accounting",
                        name: routeNames.AccountingPage.translation_name,
                        component: () => import(/!* webpackChunkName: "AccountingPage" *!/ "../views/dashboard/accounting-page/AccountingPage"),
                        meta: {
                            mcn_permission: routeNames.AccountingPage.permission,
                            middleware: [
                                hasPermission,
                            ]
                        }
                    },*/
    {
      path: "user",
      name: routeNames.UserPage.translation_name,
      component: () => import(/* webpackChunkName: "UserPage" */"../views/dashboard/user/UserPage"),
      meta: {
        mcn_permission: routeNames.UserPage.permission,
        middleware: [hasPermission]
      },
      children: [{
        path: "user-accounts",
        name: routeNames.UserPage.children[0].translation_name,
        component: () => import(/* webpackChunkName: "UserAccounts" */"../views/dashboard/user/UserAccountsPage"),
        meta: {
          mcn_permission: routeNames.UserPage.permission,
          middleware: [hasPermission]
        }
      }, {
        path: "identity-verification",
        name: routeNames.UserPage.children[1].translation_name,
        component: () => import(/* webpackChunkName: "UserIdentityVerificationListPage" */"../views/dashboard/user-identity-verifications/UserIdentityVerificationList"),
        meta: {
          mcn_permission: routeNames.UserPage.permission,
          middleware: [hasPermission]
        }
      }]
    }, {
      path: "general-settings",
      component: () => import(/* webpackChunkName: "InvoicesPage" */"../views/dashboard/invoices/InvoicesPage"),
      meta: {
        model: routeNames.settings,
        mcn_permission: routeNames.settings.permission,
        middleware: [hasPermission]
      },
      children: [{
        path: "subscriptions",
        name: (_routeNames$settings$ = routeNames.settings.children) === null || _routeNames$settings$ === void 0 || (_routeNames$settings$ = _routeNames$settings$[0]) === null || _routeNames$settings$ === void 0 ? void 0 : _routeNames$settings$.translation_name,
        component: () => import(/* webpackChunkName: "SubscriptionInvoices" */"../views/dashboard/invoices/SubscriptionInvoices"),
        meta: {
          mcn_permission: (_routeNames$settings$2 = routeNames.settings.children) === null || _routeNames$settings$2 === void 0 || (_routeNames$settings$2 = _routeNames$settings$2[0]) === null || _routeNames$settings$2 === void 0 ? void 0 : _routeNames$settings$2.permission,
          middleware: [hasPermission]
        }
      }, {
        path: 'account',
        name: (_routeNames$settings$3 = routeNames.settings.children) === null || _routeNames$settings$3 === void 0 || (_routeNames$settings$3 = _routeNames$settings$3[1]) === null || _routeNames$settings$3 === void 0 ? void 0 : _routeNames$settings$3.translation_name,
        component: () => import(/* webpackChunkName: "SettingsPage" */'../views/dashboard/SettingsPage'),
        meta: {
          mcn_permission: (_routeNames$settings$4 = routeNames.settings.children) === null || _routeNames$settings$4 === void 0 || (_routeNames$settings$4 = _routeNames$settings$4[1]) === null || _routeNames$settings$4 === void 0 ? void 0 : _routeNames$settings$4.permission,
          middleware: [hasPermission]
        }
      }]
    }]
  }, {
    path: "register/:referrer?",
    name: routeNames.registerPage.translation_name,
    component: () => import(/* webpackChunkName: "RegisterPage" */"../views/register/RegisterPage.vue"),
    meta: {
      translation_name: routeNames.registerPage.translation_name,
      middleware: [alreadyLogged]
    }
  }, {
    path: "login",
    name: routeNames.loginPage.translation_name,
    component: () => import(/* webpackChunkName: "LoginPage" */"../views/login/LoginPage.vue"),
    meta: {
      translation_name: routeNames.loginPage.translation_name,
      middleware: [alreadyLogged]
    }
  }, {
    path: "password-request",
    name: routeNames.requestPasswordPage.translation_name,
    component: () => import(/* webpackChunkName: "PasswordRequestPage" */"../views/reset-password/PasswordRequestPage.vue"),
    meta: {
      middleware: [alreadyLogged]
    }
  }, {
    path: "password-reset/:token",
    name: routeNames.resetPasswordPage.translation_name,
    component: () => import(/* webpackChunkName: "ResetPasswordPage" */"../views/reset-password/ResetPasswordPage.vue"),
    meta: {
      middleware: [alreadyLogged]
    }
  }, {
    path: "validation-request",
    name: routeNames.registerConfirmationPage.translation_name,
    component: () => import(/* webpackChunkName: "RegisterConfirmationPage" */"../views/RegisterConfirmationPage.vue"),
    meta: {
      middleware: [isLogged]
    }
  }, {
    path: "instagram/redirect",
    name: routeNames.instagramRedirectPage.translation_name,
    component: () => import(/* webpackChunkName: "InstagramRedirectPage" */"../views/InstagramRedirectPage.vue"),
    meta: {}
  }, {
    path: "playground",
    name: "playground",
    component: () => import(/* webpackChunkName: "PlaygroundPage" */"../views/playground/Playground"),
    meta: {}
  }]
};
const routes = [dashBoardLang, {
  path: "/:lang/email-verification/:token",
  name: "email-verification",
  meta: {
    middleware: [emailVerification]
  },
  component: () => import(/* webpackChunkName: "VerifyEmailPage" */"../views/VerifyEmailPage.vue")
}, {
  path: "/:lang/access-denied",
  name: "access-denied",
  component: () => import(/* webpackChunkName: "NoPermissionPage" */"../views/dashboard/NoPermission")
}, {
  path: "*",
  name: "not-found",
  component: () => import(/* webpackChunkName: "NotFoundPage" */"../views/NotFoundPage.vue")
}];
const router = new VueRouter({
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;
    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }
    return goTo(scrollTo);
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes
});
router.beforeEach(async (to, from, next) => {
  var _reg$exec;
  let fullPath = to.fullPath.replace(/^\/$/g, '');
  let reg = new RegExp(`^\/(${languages.map(lang => lang.value).join('|')})`);
  if ((_reg$exec = reg.exec(fullPath)) !== null && _reg$exec !== void 0 && _reg$exec.length) {
    let language = languages.find(language => {
      var _to$params$lang;
      return language.value === ((_to$params$lang = to.params.lang) !== null && _to$params$lang !== void 0 ? _to$params$lang : 'en');
    });
    await store.dispatch('setLanguage', {
      language: language.value,
      rtl: language.rtl
    });
    let middlewares = to.matched.flatMap(matchedRoute => {
      var _matchedRoute$meta;
      return matchedRoute === null || matchedRoute === void 0 || (_matchedRoute$meta = matchedRoute.meta) === null || _matchedRoute$meta === void 0 ? void 0 : _matchedRoute$meta.middleware;
    }).filter(mR => mR);
    return middlewares.length ? middlewares[0]({
      to,
      from,
      next
    }, store, middlewares) : next();
  }
  return next(['/', i18n.locale, fullPath].join(''));
});
router.afterEach(to => {
  document.title = String(i18n.t(to.name));
});
export default router;